import React, { useEffect, useId, useRef, useState } from 'react';

/** Shared settings dialog; edits stay in the editor draft until its Save action. */
export default function EditorSettings({ title, t, children }) {
  const [open, setOpen] = useState(false);
  const dialogRef = useRef(null);
  const triggerRef = useRef(null);
  const titleId = useId();

  useEffect(() => {
    if (!open) return;
    dialogRef.current.showModal();
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = previousOverflow; };
  }, [open]);

  const close = () => {
    dialogRef.current?.close();
    setOpen(false);
    triggerRef.current?.focus();
  };

  return (
    <>
      <button ref={triggerRef} type="button" className="ae-btn-secondary ae-settings-button" aria-label={title} title={title} aria-haspopup="dialog" onClick={() => setOpen(true)}>
        <i className="fa-solid fa-gear" aria-hidden="true" />
      </button>
      {open && (
        <dialog ref={dialogRef} className="ae-settings-dialog" aria-labelledby={titleId} onCancel={(event) => { event.preventDefault(); close(); }} onClick={(event) => { if (event.target === event.currentTarget) close(); }}>
          <div className="ae-settings-panel">
            <header className="ae-settings-header">
              <h2 id={titleId}>{title}</h2>
              <button type="button" className="ae-btn-secondary ae-settings-button" aria-label={t('assessmentEditor.close')} onClick={close}><i className="fa-solid fa-xmark" aria-hidden="true" /></button>
            </header>
            <div className="ae-settings-body">{children}</div>
            <footer className="ae-settings-footer">
              <p className="ae-inline-note">{t('assessmentEditor.settingsSaveHint')}</p>
              <button type="button" className="ae-btn-primary" onClick={close}>{t('assessmentEditor.done')}</button>
            </footer>
          </div>
        </dialog>
      )}
    </>
  );
}
